import { ButtonLink } from '../components/Button';
import { Reveal } from '../components/Reveal';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export default function NotFound() {
  useDocumentTitle('Page not found');

  return (
    <div className="bg-gradient-to-b from-mint-100 to-cream">
      <div className="mx-auto max-w-2xl px-6 py-24 text-center sm:px-8 sm:py-32">
        <Reveal>
          <div className="rounded-blob bg-white px-8 py-14 shadow-soft">
            <span aria-hidden="true" className="text-5xl">
              🧸
            </span>
            <h1 className="mt-6 text-3xl">This page wandered off.</h1>
            <p className="mt-4 leading-relaxed">
              I couldn&apos;t find the page you were looking for. Let&apos;s get you back to
              somewhere friendly.
            </p>
            <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
              <ButtonLink to="/">Take me home</ButtonLink>
              <ButtonLink to="/contact" variant="quiet">
                Get in touch
              </ButtonLink>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
